var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"sidebar-link-group pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0",class:_vm.activeCondition && 'sidebar-link-group--active'},[_vm._t("default",null,{"handleClick":_vm.handleClick,"expanded":_vm.expanded})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }